function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M119.942 58.3529C118.035 38.4068 105.439 21.5641 87.8998 13.3416L80.7285 20.4235L60.2353 0.185668C60.4968 0.168451 60.7558 0.149992 61.0134 0.131634C61.9462 0.0651503 62.8604 0 63.8075 0C97.5959 0 125.26 25.6753 128 58.3529H119.942ZM42.8105 9.24516C45.9519 6.12089 51.0534 6.12089 54.1948 9.24516L118.742 73.4396C121.883 76.5638 121.883 81.6374 118.742 84.7617L84.5621 118.755C81.4206 121.879 76.3191 121.879 73.1777 118.755L8.63059 54.5604C5.48915 51.4362 5.48915 46.3626 8.63059 43.2383L42.8105 9.24516ZM78.8633 112.941L14.4314 48.9463L48.5361 15.0588L112.941 79.0537L78.8633 112.941ZM8.05763 69.0196C9.96461 89.1802 22.5614 106.204 40.1002 114.515L47.2715 107.357L67.7647 127.812C67.5032 127.83 67.2442 127.848 66.9866 127.867C66.0537 127.934 65.1396 128 64.1925 128C30.4041 128 2.7396 102.049 0 69.0196H8.05763Z",
  fill: "#222222"
});

var SvgDeviceRotate = function SvgDeviceRotate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeviceRotate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/device-rotate.bd0d6514.svg";
export { ForwardRef as ReactComponent };